<template>
    <div>
        <transition name="fade" mode="out-in">
            <div key="1" v-if="paso === 1" id="paso-1">
                <BuscarAbonadoComponent
                    :busqueda-inicial="busquedaAbonado"
                    :disabled="showInfoAbonado"
                    @busqueda-actualizada="actualizarBusquedaAbonado"
                    @abonadoEncontrado="abonadoEncontrado"
                />

                <b-row v-if="showInfoAbonado && abonado?.info_abonado">
                    <b-col cols="12" md="9">
                        <b-row>
                            <b-col cols="12" class="pt-3">
                                <span class="h3 m-0">{{ esUcamCb ? 'Información del abonado a renovar:' : 'Información del abonado:' }}</span>
                            </b-col>
                            <b-col cols="12" class="p-2 ml-2">
                                <span class="h4 m-0">Nombre completo: {{ abonado.info_abonado.nombre_completo }}</span>
                            </b-col>
                            <b-col cols="12" class="pl-2 pb-2 ml-2">
                                <span class="h4 m-0">Email: {{ abonado.info_abonado.email }}</span>
                            </b-col>
                            <b-col cols="12" class="pl-2 pb-2 ml-2">
                                <span class="h4 m-0">DNI: {{ abonado.info_abonado.dni }}</span>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" md="3" class="tw:flex tw:justify-end tw:items-start tw:pt-3">
                        <Button data-cy="volver-a-buscar-abonado" @click.prevent="volverABuscarAbonado">Atrás</Button>
                    </b-col>
                    <b-col cols="12" v-if="!mostrar_opciones">
                        <button
                            v-if="abonado.asiento_disponible"
                            class="button large-button btn-block effect-button"
                            :disabled="disableContinuar"
                            @click="continuarObtenerZonasConAsiento"
                        >
                            <span>Continuar</span>
                        </button>
                        <span class="d-block text-center" v-else>
                            El Asiento que corresponde a este abono ya está ocupado / o no hay precios disponibles para este asiento.
                        </span>
                    </b-col>
                </b-row>

                <div class="col-12 mt-3" id="opciones-abonado" v-if="mostrar_opciones && evento.tiene_recinto">
                    <div class="row">
                        <div class="col-6">
                            <button
                                class="button large-button btn-block effect-button"
                                v-if="asiento_disponible"
                                @click="handleContinuarConAsiento"
                                data-cy="continuar-con-mi-asiento"
                            >
                                <span>Continuar con mi asiento</span>
                            </button>
                            <button class="button large-button btn-block btn-danger" v-else disabled>
                                <small>
                                    El Asiento que corresponde a su abono ya está ocupado / o no hay precios disponibles para este
                                    asiento.
                                </small>
                            </button>
                        </div>
                        <div class="col-6">
                            <button
                                v-if="puede_cambiar"
                                class="button large-button btn-block effect-button"
                                :disabled="isButtonDisabled"
                                @click="handleSeleccionarNuevoAsiento"
                                data-cy="seleccionar-nuevo-asiento"
                            >
                                <span>Seleccionar un nuevo asiento</span>
                            </button>
                        </div>
                    </div>

                    <SeleccionarZonaComponent
                        v-if="evento && abonado_encontrado && puede_cambiar && mostrar_recinto"
                        ref="selectorZona"
                        class="col-12 mt-4"
                        :evento="evento"
                        :mode="mode"
                        :puede_cambiar="puede_cambiar"
                        :sesion_id="sesion.id"
                        :asientos="asientos"
                        :entradas="entradasLocal"
                        :datos_compradores="datos_compradores"
                        @mapa-listo="alListoElMapa"
                        @getZonasFormateadas="getZonasFormateadas"
                        @goTo="finalizarPasoUno"
                    />
                </div>
            </div>
            <div key="2" v-if="paso >= 2" class="mt-3" id="paso-2">
                <!-- El `v-show` va en un envoltorio interno, no en el hijo de la transición:
                     con `mode="out-in"`, un elemento en `display: none` no dispara la salida
                     y el paso 1 no llegaba a insertarse (la zona quedaba vacía). -->
                <div v-show="paso === 2 || !vinoDeContinuarConAsiento" id="paso-2-contenido">
                    <div v-if="paso === 2 && mostrar_opciones && puede_cambiar && !vinoDeContinuarConAsiento" class="row">
                        <div class="col-12 col-md-10"></div>
                        <div class="pr-0 mb-3 col-12 col-md-2">
                            <Button data-cy="volver-a-opciones-abonado" @click.prevent="volverAOpcionesAbonado">Atrás</Button>
                        </div>
                    </div>
                    <PasoDosComponent
                        v-if="zonaTieneButacas"
                        :key="`pasoDos-${pasoDosKey}`"
                        :evento="evento"
                        :zona="zona_seleccionada"
                        :zonas_formateadas="zonas_formateadas"
                        :datos_compradores="datos_compradores"
                        :datos_abonado="abonado && abonado.info_abonado"
                        :recinto="recinto"
                        :entradas="entradasLocal"
                        :puede_cambiar="puede_cambiar"
                        :dia_abonado="dia_abonado"
                        :place="evento.place_obj"
                        :continuarConAsiento="continuarConAsiento"
                        :mode="mode"
                        :bloquearPasoDos="bloquearPasoDos"
                        :allow_blocked_seats="true"
                        @resetDatos="resetDatos"
                        @goTo="finalizarPasoDos"
                        @actualizarEntradas="resetPaso3"
                    />
                    <PasoDosRAComponent
                        v-else-if="zona_seleccionada"
                        :key="`pasoDosRA-${pasoDosKey}`"
                        :zona="zona_seleccionada"
                        :datos_compradores="datos_compradores"
                        :recinto="evento.place_obj"
                        :diaAbonado="dia_abonado"
                        :preciosAbonado="zona_seleccionada.precios_abonados || zona_seleccionada.precios"
                        :preciosAcompanante="zona_seleccionada.precios_acompanantes || []"
                        :asientosMinimos="1 + (evento.n_acompanantes_min || 0)"
                        :asientosMaximos="1 + (evento.n_acompanantes || 0)"
                        :bloquearPasoDos="bloquearPasoDos"
                        :datosAbonado="abonado && abonado.info_abonado"
                        :preseleccionarPlazaAbonado="preseleccionarPlazaAbonado"
                        :continuarConAsiento="continuarConAsiento && zonaTieneButacas"
                        @resetDatos="resetDatos"
                        @goTo="finalizarPasoDos"
                        @cambiarPaso="volverASeleccionDeZona"
                    />
                </div>
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div key="3" v-if="paso >= 3" class="mt-3" id="paso-3">
                <PasoTresComponent
                    :evento="evento"
                    :abonado="abonado"
                    :event_id="evento.id"
                    :sesion_id="sesion.id"
                    :carrito_id="carrito_id"
                    :datos_compradores="datos_compradores"
                    :entradas_seleccionadas="entradasLocal"
                    :solicitar_datos="evento.solicitar_datos"
                    :etiquetaVolver="vinoDeContinuarConAsiento ? 'Atrás' : 'Cambiar butacas'"
                    @volver="volver"
                    @goTo="finalizarPasoTres"
                />
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div key="4" v-if="paso >= 4" class="mt-3" id="paso-4">
                <PasoCuatroComponent
                    :evento="evento"
                    :mode="mode"
                    :recinto="recinto"
                    :datos_compra="datos_compra"
                    :email="email"
                    :carrito_id="carrito_id"
                    :whatsapp="whatsapp"
                    @goTo="goTo"
                    @volverAtras="volverAPaso3"
                />
            </div>
        </transition>
        <VisibilidadReducida :zona="zona_seleccionada" @aceptar="AceptarVisibilidadReducida"/>
    </div>
</template>

<script>
    import BuscarAbonadoComponent from '@/components/backend/stepper/components/BuscarAbonadoComponent';
    import SeleccionarZonaComponent from '@/components/backend/stepper/components/SeleccionarZonaComponent';
    import PasoDosComponent from '@/components/backend/stepper/eventos/PasoDosComponent.vue';
    import PasoDosRAComponent from '@/components/backend/stepper/eventos/PasoDosRAComponent.vue';
    import PasoTresComponent from '@/components/backend/stepper/eventos/PasoTresComponent.vue';
    import PasoCuatroComponent from '@/components/backend/stepper/eventos/PasoCuatroComponent.vue';
    import Button from '@/modules/admin/ui/Button.vue';
    import { TEATRO_HASH_UCAM_CB } from '@/constants/teatros';
    import VisibilidadReducida from '@/components/backend/stepper/eventos/Modal/VisibilidadReducida.vue'

    export default {
        props: ['evento', 'sesion', 'recinto', 'entradas', 'paso', 'mode'],
        data() {
            return {
                datos_compradores: [],
                dia_abonado: true,
                zona_seleccionada: null,
                datos_compra: null,
                puede_cambiar: false,
                asientos: [],
                mostrar_opciones: false,
                abonado_encontrado: false,
                asiento_disponible: false,
                carrito_id: null,
                zonas_formateadas: null,
                zonas: [],
                mostrar_recinto: false,
                // Un solo desplazamiento por activación del mapa: se marca cuando ya
                // se ha bajado al bloque y se limpia al volver a pedir asiento.
                mapa_desplazado: false,
                continuarConAsiento: false,
                // Marca propia del botón «Continuar con mi asiento»: `continuarConAsiento`
                // también se activa desde «Cambiar de asiento» (preselección), y aquí lo
                // que importa es no ofrecer «Cambiar butacas» a quien no va a elegir otra.
                vinoDeContinuarConAsiento: false,
                abonado: null,
                busquedaAbonado: {},
                isButtonDisabled: false,
                showInfoAbonado: false,
                disableContinuar: false,
                entradasLocal: [],
                pasoDosKey: 0,
                bloquearPasoDos: false
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            esUcamCb() {
                return this.configuracion?.hash_teatro === TEATRO_HASH_UCAM_CB;
            },
            zonaTieneButacas() {
                const zona = this.zona_seleccionada;

                if (!zona) {
                    return false;
                }

                if (zona.tiene_plazas === 0) {
                    return true;
                }

                // El mapa de secciones puede emitir el objeto de región sin el
                // discriminador de taquilla. Si conserva with_seats=true, la
                // selección correcta es el mapa de butacas; los datos completos
                // con tiene_plazas explícito siguen prevaleciendo.
                const faltaTipoPlazas = zona.tiene_plazas === undefined || zona.tiene_plazas === null;
                return faltaTipoPlazas && zona.tiene_recinto && zona.with_seats === true;
            },
            preseleccionarPlazaAbonado() {
                const plazaAbonado = this.abonado && this.abonado.plaza;

                // Es una señal aparte de continuarConAsiento: esa bandera la usa
                // AsientosComponent para bloquear butacas, mientras este mapa debe seguir interactivo.
                return Boolean(this.continuarConAsiento && plazaAbonado && this.zona_seleccionada &&
                    !this.zonaTieneButacas && String(this.zona_seleccionada.id) === String(plazaAbonado.region_id));
            }
        },
        created(){
            this.entradasLocal = [...this.entradas];
        },
        watch: {
            entradas: {
                handler(newVal){
                    this.entradasLocal = [...newVal]
                },
                deep: true
            }
        },
        methods: {
            actualizarBusquedaAbonado(busqueda) {
                this.busquedaAbonado = { ...busqueda };
            },
            volverABuscarAbonado() {
                this.abonado = null;
                this.abonado_encontrado = false;
                this.showInfoAbonado = false;
                this.mostrar_opciones = false;
                this.asiento_disponible = false;
                this.puede_cambiar = false;
                this.datos_compradores = [];
                this.asientos = [];
                this.$nextTick(() => this.scrollTo('#paso-1'));
            },
            handleContinuarConAsiento() {
                this.isButtonDisabled = true;
                this.continuarConMiAsiento(this.puede_cambiar);
            },
            handleSeleccionarNuevoAsiento() {
                this.isButtonDisabled = true;
                this.seleccionarNuevoAsiento();
            },
            resetDatos(new_zona) {
                this.pasoDosKey += 1;
                this.datos_compradores = [];
                this.zona_seleccionada = this.resolverZona(new_zona);
            },
            resolverZona(zona, zonasFormateadas = this.zonas_formateadas) {
                if (!zona || !Array.isArray(zonasFormateadas)) {
                    return zona;
                }

                return zonasFormateadas.find(zonaFormateada => String(zonaFormateada.id) === String(zona.id)) || zona;
            },
            getZonasFormateadas(zonas_formateadas){
                this.zonas_formateadas = zonas_formateadas;
                this.zonas = zonas_formateadas;
            },
            /**
             * Bloquea el asiento que el abonado ya tiene sin pedir la lista de
             * zonas: la búsqueda del abonado devuelve la butaca numerada
             * (`abonado.asiento`) o la plaza de región anexa (`abonado.plaza`) con
             * su zona, que es lo único que necesita el bloqueo en taquilla.
             */
            continuarConMiAsiento(cambiar) {
                if (!this.asiento_disponible || this.datos_compradores.length === 0) {
                    this.$toast.error('El asiento que corresponde a su abono no está disponible');
                    this.isButtonDisabled = false;
                    return;
                }

                this.continuarConAsiento = true;
                this.vinoDeContinuarConAsiento = true;

                const abonado = {
                    dia_abonado: 1,
                    datos_compradores: this.datos_compradores,
                    entradas: this.entradasLocal,
                    asientos: this.asientos,
                    puede_cambiar: cambiar
                };

                if (this.abonado && this.abonado.plaza) {
                    this.bloquearPlazaDelAbonado(abonado);
                } else {
                    this.bloquearButacaDelAbonado(abonado);
                }
            },
            bloquearPlazaDelAbonado(abonado) {
                const plaza = this.abonado.plaza;
                const zona = { id: plaza.region_id, name: plaza.region_name };

                const params = {
                    filters: {},
                    event_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    zona_id: plaza.region_id,
                    data: [{ plazaId: plaza.id }],
                    datos_abonado: this.datos_compradores
                };

                this.$store.dispatch(this.config.getVuexAlias('back.event.sesiones.zonas.taquilla.bloquear-plazas'), params).then(({ data }) => {
                    if (data && data.error) {
                        this.$toast.error(data.message);
                        this.isButtonDisabled = false;
                        return;
                    }

                    sessionStorage.setItem('session_id', data.session_id);
                    this.carrito_id = data.session_id;
                    this.finalizarPasoUno(3, zona, abonado);
                }).catch(() => {
                    this.$toast.error('No se ha podido bloquear la plaza del abonado');
                    this.isButtonDisabled = false;
                });
            },
            bloquearButacaDelAbonado(abonado) {
                const asiento = this.asientos[0] && this.asientos[0].asiento;

                if (!asiento) {
                    this.$toast.error('El asiento que corresponde a su abono no está disponible');
                    this.isButtonDisabled = false;
                    return;
                }

                asiento.row = asiento.fila;
                asiento.seat = asiento.asiento;

                const params = {
                    filters: {
                        sesion_id: this.$route.params.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },
                    zona_id: asiento.zona_id,
                    asientos: [asiento],
                    datos_abonado: this.datos_compradores,
                    tid: this.configuracion.hash_teatro,
                    taquilla: 1
                };

                this.$store.dispatch(this.config.getVuexAlias('front.bloquear.asientos'), params).then(res => {
                    if(res.data.error) {
                        this.$toast.error(res.data.message);
                        this.isButtonDisabled = false;
                        return;
                    }

                    this.carrito_id = res.data.session_id;
                    this.finalizarPasoUno(3, { id: asiento.zona_id, name: asiento.zona_nombre }, abonado);
                }).catch(() => {
                    this.$toast.error("Alguno de los asientos no son válidos o se ha producido un error");
                    this.isButtonDisabled = false;
                });
            },
            asientoAbonadoDisponible(abonado) {
                const asiento = abonado && (abonado.plaza || abonado.asiento);
                const precios = abonado && abonado.precio_reducido;
                const veredictoAsiento = abonado && abonado.asiento_disponible;
                const tieneVeredictoAsiento = veredictoAsiento !== undefined && veredictoAsiento !== null;
                const asientoNoDisponible = tieneVeredictoAsiento &&
                    (!veredictoAsiento || [0, '0'].includes(veredictoAsiento));

                if (!abonado || asientoNoDisponible || abonado.comprado === true || !asiento ||
                    !Array.isArray(precios) || precios.length === 0) {
                    return false;
                }

                const tieneUbicacion = abonado.plaza
                    ? asiento.id !== undefined && asiento.id !== null && asiento.region_id !== undefined &&
                        asiento.region_id !== null && (asiento.numero !== undefined && asiento.numero !== null ||
                            asiento.fila !== undefined && asiento.fila !== null &&
                            asiento.butaca !== undefined && asiento.butaca !== null)
                    : asiento.zona_id !== undefined && asiento.zona_id !== null && asiento.fila !== undefined &&
                        asiento.fila !== null && asiento.butaca !== undefined && asiento.butaca !== null;

                if (!tieneUbicacion) {
                    return false;
                }

                if (asiento.bloqueada || asiento.bloqueada_abonos || asiento.ocupada || asiento.info_ocupada ||
                    (asiento.oculto && asiento.oculto > 0)) {
                    return false;
                }

                if (asiento.ocupado !== undefined && asiento.ocupado !== null &&
                    ![0, false, '0'].includes(asiento.ocupado)) {
                    return false;
                }

                const infoAsiento = asiento.info || {};
                const abonadoId = abonado.info_abonado && abonado.info_abonado.id;
                const idPropietario = infoAsiento.abonado_id || (infoAsiento.abonado && infoAsiento.abonado.id);
                const tieneMarcaDeAbonado = infoAsiento.es_abonado === true || infoAsiento.es_abonado === 1 ||
                    infoAsiento.es_abonado === '1' || Number(infoAsiento.abonado_lista_abonado_id) > 0;

                if (tieneMarcaDeAbonado && (!idPropietario || String(idPropietario) !== String(abonadoId))) {
                    return false;
                }

                if (idPropietario && String(idPropietario) !== String(abonadoId)) {
                    return false;
                }

                if ([false, 0, '0'].includes(asiento.libre) || [false, 0, '0'].includes(asiento.disponible)) {
                    return false;
                }

                return true;
            },
            abonadoEncontrado(abonado) {
                this.asientos = [];
                this.datos_compradores = [];
                this.asiento_disponible = false;
                // La bandera del botón «Seleccionar un nuevo asiento» se consume al usarlo
                // y viaja al paso 3: una búsqueda nueva debe dejar la opción disponible otra vez.
                this.isButtonDisabled = false;
                this.abonado = abonado;
                this.abonado_encontrado = true;

                if (this.asientoAbonadoDisponible(abonado)) {
                    this.asiento_disponible = true;
                    this.datos_compradores.push({});
                    this.asientos.push({
                        'apellidos': abonado.info_abonado.apellidos,
                        'asiento': null,
                        'precio': null,
                        'dni': '',
                        'nombre': abonado.info_abonado.nombre,
                        'telefono': ''
                    });

                    this.asientos[0].precio = {
                        'descripcion': abonado.precio_reducido[0].descripcion,
                        'gd': abonado.precio_reducido[0].price_management_taquilla ?? 0,
                        'gd_interno': abonado.precio_reducido[0].price_management_taquilla_interno ?? 0,
                        'id': abonado.precio_reducido[0].id,
                        'precio': abonado.precio_reducido[0].precio,
                        'precio_total': abonado.precio_reducido[0].precio_total,
                        'price_management_interno_taquilla': abonado.precio_reducido[0].price_management_taquilla_interno ?? 0,
                        'price_management_taquilla': abonado.precio_reducido[0].price_management_taquilla ?? 0
                    };

                    if (!abonado.plaza) {
                        this.asientos[0].asiento = {
                            'asiento': abonado.asiento.butaca,
                            'event_ticket_id': abonado.precio_reducido[0].id,
                            'fila': abonado.asiento.fila,
                            'zona_id': abonado.asiento.zona_id,
                            'zona_nombre': abonado.asiento.zona
                        };
                        this.datos_compradores[0].asiento = {
                            'asiento': abonado.asiento.butaca,
                            'event_ticket_id': abonado.precio_reducido[0].id,
                            'fila': abonado.asiento.fila,
                            'zona_id': abonado.asiento.zona_id,
                            'zona_nombre': abonado.asiento.zona
                        };

                        this.datos_compradores[0].id = abonado.info_abonado.id;
                    } else {
                        this.asientos[0].id = abonado.plaza.id;
                        this.asientos[0].butaca = abonado.plaza.butaca;
                        this.asientos[0].fila = abonado.plaza.fila;
                        this.asientos[0].zona_id = abonado.plaza.region_id;
                        this.asientos[0].zona_nombre = abonado.plaza.region_name;
                        this.asientos[0].nombre_sector = abonado.plaza.sector_name;
                        this.asientos[0].event_ticket_id = abonado.precio_reducido[0].id;
                        this.asientos[0].abonado_id = abonado.info_abonado.id;

                        this.datos_compradores[0].id = abonado.plaza.id;
                        this.datos_compradores[0].butaca = abonado.plaza.butaca;
                        this.datos_compradores[0].fila = abonado.plaza.fila;
                        this.datos_compradores[0].zona_id = abonado.plaza.region_id;
                        this.datos_compradores[0].zona_nombre = abonado.plaza.region_name;
                        this.datos_compradores[0].nombre_sector = abonado.plaza.sector_name;
                        this.datos_compradores[0].event_ticket_id = abonado.precio_reducido[0].id;
                        this.datos_compradores[0].abonado_id = abonado.info_abonado.id;
                    }

                }

                if (this.datos_compradores.length > 0) {
                    if(!abonado.plaza) {
                        this.datos_compradores[0].id = abonado.info_abonado.id;
                    }

                    this.datos_compradores[0].email = abonado.info_abonado.email;
                    this.datos_compradores[0].nombre = abonado.info_abonado.nombre;
                    this.datos_compradores[0].apellidos = abonado.info_abonado.apellidos;
                    this.datos_compradores[0].abonado_id = abonado.info_abonado.id;
                    this.datos_compradores[0].precios = [];

                    // Esta normalización es el respaldo cuando la plaza aún no ha entregado
                    // su fila de `butacas`: se copian los gastos de **taquilla**, nunca los de
                    // online (`price_management`/`price_management_online`), porque el paso 3
                    // suma `price_management_taquilla` y el abonado veía 6 + 1 = 7,00.
                    for (let i in abonado.precio_reducido) {
                        this.datos_compradores[0].precios.push({
                            'descripcion': abonado.precio_reducido[i].descripcion,
                            'gd': abonado.precio_reducido[i].price_management_taquilla ?? 0,
                            'gd_interno': abonado.precio_reducido[i].price_management_taquilla_interno ?? 0,
                            'price_management_interno_taquilla': abonado.precio_reducido[i].price_management_taquilla_interno ?? 0,
                            'id': abonado.precio_reducido[i].id,
                            'precio': abonado.precio_reducido[i].precio,
                            'precio_total': abonado.precio_reducido[i].precio_total,
                            'price_management_taquilla': abonado.precio_reducido[i].price_management_taquilla ?? 0
                        });
                    }
                }

                this.puede_cambiar = abonado.puede_cambiar_asiento;
                this.$emit('getZonasFormateadas', this.zonas_formated);


                //Si es el majadahonda no puede cambiar de asiento
                if (this.configuracion.hash_teatro == 'xr6ASEHHSAjuAknejBfr') {
                    this.puede_cambiar = false;
                }

                this.showInfoAbonado = true;

                if (this.puede_cambiar) {
                    this.mostrar_opciones = true;
                }

                // Los botones del abonado aparecen al encontrarlo, pero la vista se quedaba
                // arriba: se baja hasta ellos para que el taquillero los vea sin buscarlos.
                this.$nextTick(() => this.scrollAOpcionesAbonado());
            },
            /**
             * Lleva la vista a los botones del abonado («Continuar con mi asiento» y
             * «Seleccionar un nuevo asiento»). El bloque se pinta tras el `$nextTick`, así que
             * se reintenta brevemente si aún no está montado. El desplazamiento es suave para
             * que se vea el salto.
             */
            scrollAOpcionesAbonado(intentos = 5) {
                const bloque = this.$el && this.$el.querySelector('#opciones-abonado');

                if (bloque && typeof bloque.scrollIntoView === 'function') {
                    bloque.scrollIntoView({ block: 'start', behavior: 'smooth' });
                    return;
                }

                if (intentos > 0) {
                    setTimeout(() => this.scrollAOpcionesAbonado(intentos - 1), 100);
                }
            },
            continuarObtenerZonasConAsiento() {
                this.disableContinuar = true;
                this.$nextTick(function() {
                    this.continuarConMiAsiento(this.puede_cambiar);
                });
            },
            bloquearButacas() {
                const data = this.datos_compradores.map(datos_comprador => {
                    return { plazaId: datos_comprador.id }
                });

                const params = {
                    filters: {},
                    event_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    zona_id: this.zona_seleccionada.id,
                    data: data,
                    datos_abonado: this.abonado.info_abonado
                }

                this.$store.dispatch(this.config.getVuexAlias('back.event.sesiones.zonas.taquilla.bloquear-plazas'), params).then(({ data }) => {
                    sessionStorage.setItem('session_id', data.session_id);
                    this.carrito_id = data.session_id;
                }).catch(() => {
                    this.$toast.error('Butaca/s ocupada/s');
                });
            },
            finalizarPasoUno(paso, zona, abonado) {
                const zonaResuelta = this.resolverZona(zona);
                const zonaEncontrada = zona && Array.isArray(this.zonas_formateadas) &&
                    this.zonas_formateadas.some(zonaFormateada => String(zonaFormateada.id) === String(zona.id));

                // El mapa de zonas puede emitir su `goTo` sin el tercer argumento
                // (su rama de venta normal): en ese caso se conservan los datos que
                // ya dejó la búsqueda del abonado en lugar de romper el flujo.
                if (abonado) {
                    this.datos_compradores = abonado.datos_compradores;
                    this.entradasLocal = abonado.entradas;
                    this.puede_cambiar = abonado.puede_cambiar;
                }

                const continuarPaso = zonaFinal => {
                    if (zonaFinal && zonaFinal.visibilidad_reducida) {
                        this.$modal.show('visibilidad-reducida');
                    }

                    if (paso >= 2 && zonaFinal) {
                        this.zona_seleccionada = zonaFinal;
                        this.pasoDosKey += 1;
                    }
                    // Solo aplica cuando hay lista de zonas (venta de un asiento nuevo);
                    // en «continuar con mi asiento» el bloqueo ya se ha hecho con el
                    // asiento del propio abonado.
                    if (Array.isArray(this.zonas_formateadas) && this.zonas_formateadas.length > 0 &&
                        this.zonas_formateadas.every(zona => zona.tiene_plazas === 1) && this.evento.tiene_recinto) {
                        this.bloquearButacas();
                    }

                    this.$emit('cambiarPaso', paso)

                    this.$nextTick(function() {
                        this.scrollTo('#entradas-seleccionadas');
                    });
                };

                if (paso === 2 && zona && !zonaEncontrada) {
                    const params = {
                        filters: {
                            evento_id: this.$route.params.evento_id,
                            sesion_id: this.$route.params.sesion_id
                        }
                    };

                    try {
                        const request = this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params);
                        Promise.resolve(request).then(res => {
                            const zonasCompletas = res && Array.isArray(res.data) ? res.data : [];
                            continuarPaso(this.resolverZona(zona, zonasCompletas));
                        }, () => continuarPaso(zona));
                    } catch (error) {
                        continuarPaso(zona);
                    }
                    return;
                }

                continuarPaso(zonaResuelta);
            },
            finalizarPasoDos(paso, datos, carrito_id) {
                if (paso >= 3) {
                    this.bloquearPasoDos = true;
                }

                if (carrito_id) {
                    this.carrito_id = carrito_id;
                }

                if (datos) {
                    this.datos_compradores = datos;
                }

                if (Array.isArray(this.entradasLocal) && this.entradas.length > 0) {
                    for (let i = 0; i < this.entradasLocal.length; i++) {
                        if (this.entradasLocal[i].unidades > 0) {
                            for (let x = 0; x < this.entradasLocal[i].unidades; x++) {
                                this.datos_compradores.push({
                                    apellidos: '',
                                    asiento: {
                                        zona_nombre: 'General'
                                    },
                                    descuento: 0,
                                    dni: '',
                                    es_nuevo: true,
                                    nombre: '',
                                    precio: {
                                        descripcion: this.entradasLocal[i].name,
                                        gd: this.entradasLocal[i].price_management,
                                        gd_interno: this.entradasLocal[i].price_management_interno,
                                        price_management_taquilla: this.entradasLocal[i].price_management,
                                        id: this.entradasLocal[i].id,
                                        precio: this.entradasLocal[i].price,
                                        precio_total: this.entradasLocal[i].total_price
                                    },
                                    precios: [
                                        {
                                            descripcion: this.entradasLocal[i].name,
                                            gd: this.entradasLocal[i].price_management,
                                            gd_interno: this.entradasLocal[i].price_management_interno,
                                            id: this.entradasLocal[i].id,
                                            precio: this.entradasLocal[i].price,
                                            price_management_taquilla: this.entradasLocal[i].price_management,
                                            precio_total: this.entradasLocal[i].total_price
                                        }
                                    ],
                                    telefono: '',
                                    url_imprimir: null
                                });
                            }
                        }
                    }
                }

                this.$emit('cambiarPaso', paso)

                this.$nextTick(function() {
                    this.scrollAlPaso(paso);
                });
            },
            finalizarPasoTres(paso, datos, email, whatsapp) {
                this.email = email;
                this.whatsapp = whatsapp;
                let datos_compra = null
                if (this.zona_seleccionada != null) {
                    datos_compra = {
                        evento_id: this.evento.id,
                        sesion_id: this.sesion.id,
                        zona_id: this.zona_seleccionada.id,
                        datos_compradores: this.datos_compradores,
                        metodo_pago: datos.metodo_pago,
                        modalidad: 0,
                        tipo: false,
                        concepto: datos.concepto,
                        enviar_email: datos.enviar_email,
                        email: datos.email,
                        nombre: datos.nombre,
                        telefono: datos.telefono,
                        enviar_whatsapp: datos.enviar_whatsapp,
                        cp: datos.cp,
                        recinto: true,
                        nombre_comprador: datos.nombre_comprador,
                        apellidos_comprador: datos.apellidos_comprador,
                        dni_comprador: datos.dni_comprador,
                        telefono_comprador: datos.telefono_comprador
                    };
                } else {
                    datos_compra = {
                        evento_id: this.evento.id,
                        sesion_id: this.sesion.id,
                        zona_id: 1,
                        datos_compradores: this.datos_compradores,
                        entradas: this.entradasLocal,
                        metodo_pago: datos.metodo_pago,
                        modalidad: 0,
                        tipo: false,
                        concepto: datos.concepto,
                        enviar_email: datos.enviar_email,
                        email: datos.email,
                        nombre: datos.nombre,
                        telefono: datos.telefono,
                        enviar_whatsapp: datos.enviar_whatsapp,
                        cp: datos.cp,
                        recinto: false,
                        nombre_comprador: datos.nombre_comprador,
                        apellidos_comprador: datos.apellidos_comprador,
                        dni_comprador: datos.dni_comprador,
                        telefono_comprador: datos.telefono_comprador
                    };
                }
                if (datos) {
                    this.datos_compra = datos_compra;
                }
                this.$emit('cambiarPaso', paso)

                this.$nextTick(function() {
                    this.scrollAlPaso(paso);
                });
            },
            /**
             * Lleva la vista al bloque del paso. Se usa `scrollIntoView` y no `$scrollTo`
             * (vue-scrollto) porque éste calcula desplazamientos de contenedor y dejaba la
             * vista corta: al continuar la compra desde «Tus entradas» el paso 4 aparecía
             * sin desplazar la página. El bloque puede no estar montado en el primer tick,
             * así que se reintenta brevemente. El desplazamiento es suave para que se vea.
             */
            scrollAlPaso(paso, intentos = 5) {
                const bloque = this.$el && this.$el.querySelector('#paso-' + paso);

                if (bloque && typeof bloque.scrollIntoView === 'function') {
                    bloque.scrollIntoView({ block: 'start', behavior: 'smooth' });
                    return;
                }

                if (intentos > 0) {
                    setTimeout(() => this.scrollAlPaso(paso, intentos - 1), 100);
                }
            },
            scrollTo(paso) {
                this.$scrollTo(paso, 100)
            },
            resetPaso3() {
                if (this.paso >= 3) {
                    this.$emit('cambiarPaso', 2)
                    this.$nextTick(function() {
                        this.$emit('cambiarPaso', 3)
                    });
                }
            },
            /**
             * «Cambiar zona» del paso de plazas emite `('cambiarPaso', 1, true)`. Ese `true`
             * (reiniciar) llega al padre como `resetearEntradas(true)`, que recarga el evento
             * y devuelve la pestaña a «Venta normal», perdiendo el flujo del abonado. Aquí
             * solo debe volver al paso anterior, donde está el selector de zona.
             */
            volverAOpcionesAbonado() {
                const abonado = this.abonado;
                this.bloquearPasoDos = false;
                this.continuarConAsiento = false;
                this.vinoDeContinuarConAsiento = false;
                this.mostrar_recinto = false;
                this.mapa_desplazado = false;
                this.zona_seleccionada = null;
                this.pasoDosKey += 1;
                this.isButtonDisabled = false;
                this.$emit('cambiarPaso', 1);
                this.$nextTick(() => {
                    if (abonado) {
                        this.abonadoEncontrado(abonado);
                    } else {
                        this.scrollAOpcionesAbonado();
                    }
                });
            },
            volverASeleccionDeZona(paso) {
                this.$emit('cambiarPaso', paso, false);
            },
            /**
             * «Atrás» del paso 4: vuelve a «Tus entradas» (paso 3). El botón emite
             * `volverAtras`, pero el abonado no lo escuchaba: el paso 4 seguía en pantalla y
             * la vista no bajaba. Se cambia de paso y se desplaza con el helper común.
             */
            volverAPaso3() {
                this.disableInput = false;
                this.$emit('cambiarPaso', 3);
                this.$nextTick(() => this.scrollAlPaso(3));
            },
            volver() {
                // Libera las butacas bloqueadas y vuelve al paso anterior. En el flujo
                // «Continuar con mi asiento», el paso 3 debe regresar al panel de opciones
                // del abonado, conservando su ficha y la butaca original para que pueda
                // volver a elegir entre continuar o cambiar de asiento.
                this.borrarSesion();
                this.carrito_id = null;
                this.bloquearPasoDos = false;

                if (this.vinoDeContinuarConAsiento) {
                    this.volverAOpcionesAbonado();
                    return;
                }

                this.$emit('cambiarPaso', 2);
            },
            borrarSesion() {
                const params = {
                    filters: {
                        session_id: this.carrito_id,
                        tid: this.configuracion.hash_teatro
                    },
                    session_id: this.carrito_id,
                    tid: this.configuracion.hash_teatro
                }

                this.$store.dispatch(this.config.getVuexAlias('front.sesion.delete'), params);
            },
            goTo(paso) {
                if (paso < this.paso) {
                    if (paso === 1) {
                        this.$emit('resetearEntradas', true);
                        this.datos_compra = [];
                        this.datos_compra.metodo_pago = [];
                        this.zona_seleccionada = [];
                        this.datos_compradores = [];
                    }
                    if (paso === 2) {
                        this.$emit('cambiarPaso', 1)
                        this.$emit('resetearEntradas', true);
                        this.datos_compra = null;
                        this.datos_compradores = [];
                        if (!this.evento.tiene_recinto) {
                            this.getEvento();
                        }
                    }
                    this.$nextTick(function() {
                        this.$emit('cambiarPaso', paso)
                    });
                }
            },
            seleccionarNuevoAsiento() {
                const asientoDisponible = this.asientoAbonadoDisponible(this.abonado);
                this.asiento_disponible = asientoDisponible;
                this.continuarConAsiento = asientoDisponible;
                this.vinoDeContinuarConAsiento = false;

                if (!asientoDisponible) {
                    this.datos_compradores = [];
                    this.asientos = [];
                }

                this.mostrar_recinto = true;
                this.mapa_desplazado = false;

                // Aquí no se desplaza nada: el bloque crece en dos fases (primero las
                // zonas del selector y después el SVG del mapa), así que bajar ahora
                // dejaba un salto corto que luego se estiraba. El desplazamiento se
                // enlaza al aviso `mapa-listo` del selector, que solo llega con el mapa
                // cargado y pintado.
            },
            /**
             * Un único desplazamiento suave al bloque del mapa, ya con su altura
             * definitiva. Se ignoran los avisos posteriores (el mapa reavisa al cambiar
             * de nivel) y no hace falta la reafirmación a los 2 s de antes: era
             * justamente el segundo tirón que se veía.
             */
            alListoElMapa() {
                if (this.mapa_desplazado) {
                    return;
                }

                const selector = this.$refs.selectorZona && this.$refs.selectorZona.$el;

                if (!selector || typeof selector.scrollIntoView !== 'function') {
                    return;
                }

                this.mapa_desplazado = true;
                selector.scrollIntoView({ block: 'start', behavior: 'smooth' });
            },
            AceptarVisibilidadReducida(){
                this.$modal.hide('visibilidad-reducida');
            }
        },
        components: {
            BuscarAbonadoComponent, SeleccionarZonaComponent, PasoDosComponent, PasoDosRAComponent, PasoTresComponent, PasoCuatroComponent,
            Button, VisibilidadReducida
        }
    }
</script>
